import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import { Progress } from 'antd';
import { useId } from 'react';
import { useTheme } from 'styled-components';
import {
  ManagedProgressHeader,
  ManagedProgressSection,
} from './styles';

interface ManagedProgramProgressProps {
  percentage?: number;
}

const ManagedProgramProgress = ({
  percentage,
}: ManagedProgramProgressProps) => {
  const { t } = useTranslations();
  const theme = useTheme();
  const titleId = useId();
  const normalizedPercentage = Number.isFinite(percentage)
    ? Math.min(100, Math.max(0, Math.round(percentage ?? 0)))
    : 0;

  return (
    <ManagedProgressSection aria-labelledby={titleId}>
      <ManagedProgressHeader>
        <Typography id={titleId} elementTheme="subtitle1" bold>
          {t('document-journey|managedProgramProgressTitle')}
        </Typography>
        <Typography
          elementTheme="subtitle1"
          bold
          color={theme.colors.purple_2}
        >
          {normalizedPercentage} %
        </Typography>
      </ManagedProgressHeader>
      <Progress
        percent={normalizedPercentage}
        showInfo={false}
        strokeColor={theme.colors.green_high_contrast}
        trailColor={theme.colors.green_4}
        strokeLinecap="round"
        size={['100%', 12]}
      />
      <Typography elementTheme="body3" color={theme.colors.grey_2}>
        {t('document-journey|managedProgramProgressDescription')}
      </Typography>
    </ManagedProgressSection>
  );
};

export default ManagedProgramProgress;
